import { render, staticRenderFns } from "./c-common-tab.vue?vue&type=template&id=36b2e4b5&scoped=true"
import script from "./c-common-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./c-common-tab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-common-tab.vue?vue&type=style&index=0&id=36b2e4b5&prod&lang=less&scoped=true"
import style1 from "./c-common-tab.vue?vue&type=style&index=1&id=36b2e4b5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2e4b5",
  null
  
)

export default component.exports